import { type ButtonHTMLAttributes, type ReactNode } from 'react';

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'outline-secondary' | 'danger' | 'success' | 'ghost-primary' | 'ghost-secondary' | 'ghost-danger';
  size?: 'sm' | 'md' | 'lg';
  isLoading?: boolean;
  loadingText?: string;
  icon?: ReactNode;
  children: ReactNode;
}

export function Button({
  variant = 'primary',
  size = 'md',
  isLoading = false,
  loadingText = 'Ładowanie...',
  icon,
  children,
  className,
  disabled,
  type = 'button',
  ...props
}: ButtonProps) {
  const getVariantClass = () => {
    switch (variant) {
      case 'primary':
        return 'btn-primary';
      case 'secondary':
        return 'btn-secondary';
      case 'outline':
        return 'btn-outline-primary';
      case 'outline-secondary':
        return 'btn-outline-secondary';
      case 'danger':
        return 'btn-danger';
      case 'success':
        return 'btn-success';
      case 'ghost-primary':
        return 'btn-ghost-primary';
      case 'ghost-secondary':
        return 'btn-ghost-secondary';
      case 'ghost-danger':
        return 'btn-ghost-danger';
      default:
        return 'btn-primary';
    }
  };

  const getSizeClass = () => {
    switch (size) {
      case 'sm':
        return 'btn-sm';
      case 'lg':
        return 'btn-lg';
      default:
        return '';
    }
  };

  const baseClassName = `btn ${getVariantClass()} ${getSizeClass()}`;
  const finalClassName = className ? `${baseClassName} ${className}` : baseClassName;

  return (
    <button type={type} className={finalClassName} disabled={isLoading || disabled} {...props}>
      {isLoading ? (
        <>
          <span className="spinner-border spinner-border-sm me-2" role="status"></span>
          {loadingText}
        </>
      ) : (
        <>
          {icon && <span className="me-2 d-inline-flex align-items-center">{icon}</span>}
          {children}
        </>
      )}
    </button>
  );
}
